// Exported to be Used internally for SB
export const IANA_TIMEZONES = [
  "Pacific/Kiritimati",
  "Pacific/Apia",
  "Pacific/Enderbury",
  "Pacific/Fakaofo",
  "Pacific/Tongatapu",
  "Pacific/Chatham",
  "Antarctica/McMurdo",
  "Asia/Anadyr",
  "Asia/Kamchatka",
  "Pacific/Auckland",
  "Pacific/Fiji",
  "Pacific/Funafuti",
  "Pacific/Kwajalein",
  "Pacific/Majuro",
  "Pacific/Nauru",
  "Pacific/Tarawa",
  "Pacific/Wake",
  "Pacific/Wallis",
  "Antarctica/Casey",
  "Antarctica/Macquarie",
  "Asia/Magadan",
  "Asia/Sakhalin",
  "Asia/Srednekolymsk",
  "Pacific/Bougainville",
  "Pacific/Efate",
  "Pacific/Guadalcanal",
  "Pacific/Kosrae",
  "Pacific/Norfolk",
  "Pacific/Noumea",
  "Pacific/Pohnpei",
  "Australia/Lord_Howe",
  "Antarctica/DumontDUrville",
  "Asia/Ust-Nera",
  "Asia/Vladivostok",
  "Australia/Brisbane",
  "Australia/Currie",
  "Australia/Hobart",
  "Australia/Lindeman",
  "Australia/Melbourne",
  "Australia/Sydney",
  "Pacific/Chuuk",
  "Pacific/Guam",
  "Pacific/Port_Moresby",
  "Pacific/Saipan",
  "Australia/Adelaide",
  "Australia/Broken_Hill",
  "Australia/Darwin",
  "Asia/Chita",
  "Asia/Dili",
  "Asia/Jayapura",
  "Asia/Khandyga",
  "Asia/Seoul",
  "Asia/Tokyo",
  "Asia/Yakutsk",
  "Pacific/Palau",
  "Australia/Eucla",
  "Asia/Pyongyang",
  "Asia/Brunei",
  "Asia/Choibalsan",
  "Asia/Hong_Kong",
  "Asia/Irkutsk",
  "Asia/Kuala_Lumpur",
  "Asia/Kuching",
  "Asia/Macau",
  "Asia/Makassar",
  "Asia/Manila",
  "Asia/Shanghai",
  "Asia/Singapore",
  "Asia/Taipei",
  "Asia/Ulaanbaatar",
  "Australia/Perth",
  "Antarctica/Davis",
  "Asia/Bangkok",
  "Asia/Barnaul",
  "Asia/Ho_Chi_Minh",
  "Asia/Hovd",
  "Asia/Jakarta",
  "Asia/Krasnoyarsk",
  "Asia/Novokuznetsk",
  "Asia/Novosibirsk",
  "Asia/Phnom_Penh",
  "Asia/Pontianak",
  "Asia/Tomsk",
  "Asia/Vientiane",
  "Indian/Christmas",
  "Asia/Yangon",
  "Indian/Cocos",
  "Antarctica/Vostok",
  "Asia/Almaty",
  "Asia/Bishkek",
  "Asia/Dhaka",
  "Asia/Omsk",
  "Asia/Qyzylorda",
  "Asia/Thimphu",
  "Asia/Urumqi",
  "Indian/Chagos",
  "Asia/Kathmandu",
  "Asia/Colombo",
  "Asia/Kolkata",
  "Antarctica/Mawson",
  "Asia/Aqtau",
  "Asia/Aqtobe",
  "Asia/Ashgabat",
  "Asia/Atyrau",
  "Asia/Dushanbe",
  "Asia/Karachi",
  "Asia/Oral",
  "Asia/Samarkand",
  "Asia/Tashkent",
  "Asia/Yekaterinburg",
  "Indian/Kerguelen",
  "Indian/Maldives",
  "Asia/Kabul",
  "Asia/Tehran",
  "Asia/Baku",
  "Asia/Dubai",
  "Asia/Muscat",
  "Asia/Tbilisi",
  "Asia/Yerevan",
  "Europe/Astrakhan",
  "Europe/Samara",
  "Europe/Saratov",
  "Europe/Ulyanovsk",
  "Indian/Mahe",
  "Indian/Mauritius",
  "Indian/Reunion",
  "Africa/Addis_Ababa",
  "Africa/Asmara",
  "Africa/Dar_es_Salaam",
  "Africa/Djibouti",
  "Africa/Juba",
  "Africa/Kampala",
  "Africa/Khartoum",
  "Africa/Mogadishu",
  "Africa/Nairobi",
  "Antarctica/Syowa",
  "Asia/Aden",
  "Asia/Amman",
  "Asia/Baghdad",
  "Asia/Bahrain",
  "Asia/Beirut",
  "Asia/Damascus",
  "Asia/Famagusta",
  "Asia/Gaza",
  "Asia/Hebron",
  "Asia/Jerusalem",
  "Asia/Kuwait",
  "Asia/Nicosia",
  "Asia/Qatar",
  "Asia/Riyadh",
  "Europe/Athens",
  "Europe/Bucharest",
  "Europe/Chisinau",
  "Europe/Helsinki",
  "Europe/Istanbul",
  "Europe/Kiev",
  "Europe/Kirov",
  "Europe/Mariehamn",
  "Europe/Minsk",
  "Europe/Moscow",
  "Europe/Riga",
  "Europe/Simferopol",
  "Europe/Sofia",
  "Europe/Tallinn",
  "Europe/Uzhgorod",
  "Europe/Vilnius",
  "Europe/Volgograd",
  "Europe/Zaporozhye",
  "Indian/Antananarivo",
  "Indian/Comoro",
  "Indian/Mayotte",
  "Africa/Blantyre",
  "Africa/Bujumbura",
  "Africa/Cairo",
  "Africa/Ceuta",
  "Africa/Gaborone",
  "Africa/Harare",
  "Africa/Johannesburg",
  "Africa/Kigali",
  "Africa/Lubumbashi",
  "Africa/Lusaka",
  "Africa/Maputo",
  "Africa/Maseru",
  "Africa/Mbabane",
  "Africa/Tripoli",
  "Antarctica/Troll",
  "Arctic/Longyearbyen",
  "Europe/Amsterdam",
  "Europe/Andorra",
  "Europe/Belgrade",
  "Europe/Berlin",
  "Europe/Bratislava",
  "Europe/Brussels",
  "Europe/Budapest",
  "Europe/Busingen",
  "Europe/Copenhagen",
  "Europe/Gibraltar",
  "Europe/Kaliningrad",
  "Europe/Ljubljana",
  "Europe/Luxembourg",
  "Europe/Madrid",
  "Europe/Malta",
  "Europe/Monaco",
  "Europe/Oslo",
  "Europe/Paris",
  "Europe/Podgorica",
  "Europe/Prague",
  "Europe/Rome",
  "Europe/San_Marino",
  "Europe/Sarajevo",
  "Europe/Skopje",
  "Europe/Stockholm",
  "Europe/Tirane",
  "Europe/Vaduz",
  "Europe/Vatican",
  "Europe/Vienna",
  "Europe/Warsaw",
  "Europe/Zagreb",
  "Europe/Zurich",
  "Africa/Algiers",
  "Africa/Bangui",
  "Africa/Brazzaville",
  "Africa/Casablanca",
  "Africa/Douala",
  "Africa/El_Aaiun",
  "Africa/Kinshasa",
  "Africa/Lagos",
  "Africa/Libreville",
  "Africa/Luanda",
  "Africa/Malabo",
  "Africa/Ndjamena",
  "Africa/Niamey",
  "Africa/Porto-Novo",
  "Africa/Tunis",
  "Africa/Windhoek",
  "Atlantic/Canary",
  "Atlantic/Faroe",
  "Atlantic/Madeira",
  "Europe/Dublin",
  "Europe/Guernsey",
  "Europe/Isle_of_Man",
  "Europe/Jersey",
  "Europe/Lisbon",
  "Europe/London",
  "Africa/Abidjan",
  "Africa/Accra",
  "Africa/Bamako",
  "Africa/Banjul",
  "Africa/Bissau",
  "Africa/Conakry",
  "Africa/Dakar",
  "Africa/Freetown",
  "Africa/Lome",
  "Africa/Monrovia",
  "Africa/Nouakchott",
  "Africa/Ouagadougou",
  "Africa/Sao_Tome",
  "America/Danmarkshavn",
  "America/Scoresbysund",
  "Atlantic/Azores",
  "Atlantic/Reykjavik",
  "Atlantic/St_Helena",
  "UTC",
  "Atlantic/Cape_Verde",
  "America/Godthab",
  "America/Miquelon",
  "America/Noronha",
  "Atlantic/South_Georgia",
  "America/St_Johns",
  "America/Araguaina",
  "America/Argentina/Buenos_Aires",
  "America/Argentina/Catamarca",
  "America/Argentina/Cordoba",
  "America/Argentina/Jujuy",
  "America/Argentina/La_Rioja",
  "America/Argentina/Mendoza",
  "America/Argentina/Rio_Gallegos",
  "America/Argentina/Salta",
  "America/Argentina/San_Juan",
  "America/Argentina/San_Luis",
  "America/Argentina/Tucuman",
  "America/Argentina/Ushuaia",
  "America/Bahia",
  "America/Belem",
  "America/Cayenne",
  "America/Fortaleza",
  "America/Glace_Bay",
  "America/Goose_Bay",
  "America/Halifax",
  "America/Maceio",
  "America/Moncton",
  "America/Montevideo",
  "America/Paramaribo",
  "America/Punta_Arenas",
  "America/Recife",
  "America/Santarem",
  "America/Sao_Paulo",
  "America/Thule",
  "Antarctica/Palmer",
  "Antarctica/Rothera",
  "Atlantic/Bermuda",
  "Atlantic/Stanley",
  "America/Anguilla",
  "America/Antigua",
  "America/Aruba",
  "America/Asuncion",
  "America/Barbados",
  "America/Blanc-Sablon",
  "America/Boa_Vista",
  "America/Campo_Grande",
  "America/Caracas",
  "America/Cuiaba",
  "America/Curacao",
  "America/Detroit",
  "America/Dominica",
  "America/Grand_Turk",
  "America/Grenada",
  "America/Guadeloupe",
  "America/Guyana",
  "America/Havana",
  "America/Indiana/Indianapolis",
  "America/Indiana/Marengo",
  "America/Indiana/Petersburg",
  "America/Indiana/Vevay",
  "America/Indiana/Vincennes",
  "America/Indiana/Winamac",
  "America/Iqaluit",
  "America/Kentucky/Louisville",
  "America/Kentucky/Monticello",
  "America/Kralendijk",
  "America/La_Paz",
  "America/Lower_Princes",
  "America/Manaus",
  "America/Marigot",
  "America/Martinique",
  "America/Montserrat",
  "America/Nassau",
  "America/New_York",
  "America/Nipigon",
  "America/Pangnirtung",
  "America/Port-au-Prince",
  "America/Port_of_Spain",
  "America/Porto_Velho",
  "America/Puerto_Rico",
  "America/Santiago",
  "America/Santo_Domingo",
  "America/St_Barthelemy",
  "America/St_Kitts",
  "America/St_Lucia",
  "America/St_Thomas",
  "America/St_Vincent",
  "America/Thunder_Bay",
  "America/Toronto",
  "America/Tortola",
  // UTC-05:00
  "America/Atikokan",
  "America/Bahia_Banderas",
  "America/Bogota",
  "America/Cancun",
  "America/Cayman",
  "America/Chicago",
  "America/Eirunepe",
  "America/Guayaquil",
  "America/Indiana/Knox",
  "America/Indiana/Tell_City",
  "America/Jamaica",
  "America/Lima",
  "America/Matamoros",
  "America/Menominee",
  "America/Merida",
  "America/Mexico_City",
  "America/Monterrey",
  "America/North_Dakota/Beulah",
  "America/North_Dakota/Center",
  "America/North_Dakota/New_Salem",
  "America/Panama",
  "America/Rainy_River",
  "America/Rankin_Inlet",
  "America/Resolute",
  "America/Rio_Branco",
  "America/Winnipeg",
  "America/Belize",
  "America/Boise",
  "America/Cambridge_Bay",
  "America/Chihuahua",
  "America/Costa_Rica",
  "America/Denver",
  "America/Edmonton",
  "America/El_Salvador",
  "America/Guatemala",
  "America/Inuvik",
  "America/Managua",
  "America/Mazatlan",
  "America/Ojinaga",
  "America/Regina",
  "America/Swift_Current",
  "America/Tegucigalpa",
  "America/Yellowknife",
  "Pacific/Easter",
  "Pacific/Galapagos",
  "America/Creston",
  "America/Dawson",
  "America/Dawson_Creek",
  "America/Fort_Nelson",
  "America/Hermosillo",
  "America/Los_Angeles",
  "America/Phoenix",
  "America/Tijuana",
  "America/Vancouver",
  "America/Whitehorse",
  "America/Anchorage",
  "America/Juneau",
  "America/Metlakatla",
  "America/Nome",
  "America/Sitka",
  "America/Yakutat",
  "Pacific/Pitcairn",
  "America/Adak",
  "Pacific/Gambier",
  "Pacific/Marquesas",
  "Pacific/Honolulu",
  "Pacific/Rarotonga",
  "Pacific/Tahiti",
  "Pacific/Midway",
  "Pacific/Niue",
  "Pacific/Pago_Pago",
] as const;

export type IanaZone = (typeof IANA_TIMEZONES)[number];
